const CLASS_NAME_SHOW = 'show';

const axios = async() => {
    const { default: axios } = await import(/* webpackChunkName: "axios" */ 'axios');

    return axios;
};

function isShown(element) {
    return element.classList.contains(CLASS_NAME_SHOW);
}

function resetDropdowns(navItemToggles) {
    let dropdownSubnavs = document.querySelectorAll('.subnav');
    if (navItemToggles) {
        for (let t = 0; t < navItemToggles.length; t++) {
            navItemToggles[t].setAttribute('aria-expanded', false);
        }
    }
    if (dropdownSubnavs) {
        for (let d = 0; d < dropdownSubnavs.length; d++) {
            dropdownSubnavs[d].classList.remove(CLASS_NAME_SHOW);
        }
    }
}

function handleAriaAndCollapsedClass(toggler, collapse, isOpen) {
    if (isOpen) {
        toggler.setAttribute('aria-expanded', false);
        collapse.classList.remove(CLASS_NAME_SHOW);
    } else {
        toggler.setAttribute('aria-expanded', true);
        collapse.classList.add(CLASS_NAME_SHOW);
    }
}

document.addEventListener('DOMContentLoaded', function() {

    // define nav toggle and click event
    const navToggle = document.querySelector('.nav-toggle');
    const navItemToggles = document.querySelectorAll('.nav__dropdown');
    navToggle.addEventListener('click', function() {
        const toggleId = navToggle.getAttribute('data-target');
        let collapeNav = document.querySelector(`${toggleId}`);
        resetDropdowns(navItemToggles);
        handleAriaAndCollapsedClass(navToggle, collapeNav, isShown(collapeNav));
    });
    navItemToggles.forEach(navItemToggle => {
        navItemToggle.addEventListener('click', function() {
            let dropdownToggleId = navItemToggle.getAttribute('data-target');
            let dropdownSubnav = document.querySelector(`${dropdownToggleId}`);
            // this for loop will hide previously clicked dropdowns
            for (let j = 0; j < navItemToggles.length; j++) {
                if (navItemToggles[j] != this) {
                    let targetDropdown = document.querySelector(`${navItemToggles[j].getAttribute("data-target")}`);
                    // reset toggle not equal to clicked target
                    navItemToggles[j].setAttribute('aria-expanded', false);
                    // reset dropdown
                    targetDropdown.classList.remove(CLASS_NAME_SHOW);
                }
            }
            handleAriaAndCollapsedClass(navItemToggle, dropdownSubnav, isShown(dropdownSubnav));
        });
    });

    // global search
    const globalSearchEl = document.querySelector('.global-search');
    const searchOpenEl = document.querySelector('.open-search');
    const searchCloseEl = document.querySelector('.close-search');

    // print button
    const printBtnEl = document.querySelector('.print-btn');

    searchOpenEl.addEventListener('click', function(){
        if (globalSearchEl) {
            searchOpenEl.setAttribute('aria-expanded', 'true');
            searchOpenEl.setAttribute('tabindex','-1');
            globalSearchEl.classList.add('open');
            document.querySelector('.search-form-input').focus();
        }
    });

    if (searchCloseEl) {
        searchCloseEl.addEventListener('click', function(){
            if (globalSearchEl) {
                searchOpenEl.setAttribute('aria-expanded', 'false')
                searchOpenEl.removeAttribute('tabindex');
                globalSearchEl.classList.remove('open');
                searchOpenEl.focus();
            }
        });
    }

    // define accordions and event listeners
    const accordionToggles = document.querySelectorAll('.accordion-toggle button');
    accordionToggles.forEach((accordionToggle) => {
        accordionToggle.addEventListener('click', (e) => {
            const el = e.target;
            const siblingEl = el.parentNode.nextElementSibling;
            handleAriaAndCollapsedClass(el, siblingEl, isShown(siblingEl));
        });
    });

    // define disclosure
    const disclosures = document.querySelectorAll('.disclosure__toggle');
    disclosures.forEach((disclosure) => {
        disclosure.addEventListener('click', (e) => {
            const el = e.target;
            const siblingEl = el.nextElementSibling;
            handleAriaAndCollapsedClass(el, siblingEl, isShown(siblingEl));
        });
    });

    const productTabs = document.querySelector('.product-tabs');
    if (productTabs) {
        import('./tabs.js');
    }

    if (printBtnEl) {
        printBtnEl.addEventListener('click', function() {
            window.print();
        })
    }

    // Reset Form CSRF Tokens
    const formieForms = document.querySelectorAll('.fui-form');
    if (formieForms.length > 0) {
        axios().then( request => {
                formieForms.forEach(form => {
                    let csrfInput = form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
                    let formHandleInput = form.querySelector('input[name="handle"]');
                    let formHandle = formHandleInput.value;
                    request.get(`/actions/formie/forms/refresh-tokens?form=${formHandle}`)
                        .then(result => { return result.data })
                        .then(result => {
                            csrfInput.outerHTML = result.csrf.input;
                            // JavaScript captcha
                            if (result.captchas && result.captchas.javascript) {
                                let jsCaptcha = result.captchas.javascript;
                                form.querySelector('input[name="' + jsCaptcha.sessionKey + '"]').value = jsCaptcha.value;
                            }
                            // Find the Duplicate captcha hidden input, so we can update it
                            if (result.captchas && result.captchas.duplicate) {
                                // Duplicate captcha
                                var duplicateCaptcha = result.captchas.duplicate;
                                form.querySelector('input[name="' + duplicateCaptcha.sessionKey + '"]').value = duplicateCaptcha.value;
                            }
                            if (form.form && form.form.formTheme) {
                                form.form.formTheme.updateFormHash();
                            }
                        })
                        .catch(error => console.error(error));
                });
            })
            .catch((error) => {
                console.log('Unable to load refresh form');
            });
    }

});

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR")
    });
}